import React, { FC, ReactNode } from 'react'
import { ButtonStyled } from './SearchButton.styles'

interface SearchButtonProps {
  onClick: () => void
  children: ReactNode
}

const SearchButton: FC<SearchButtonProps> = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>
}
export default SearchButton
